/**
 * Formats a DICOM Person Name (PN) for display.
 *
 * Supports:
 *  - Object with { Alphabetic?, Ideographic?, Phonetic? }
 *  - Plain string (e.g. "Smith^John")
 *  - Array of PN objects/strings (takes first element)
 *
 * Priority: Alphabetic → Ideographic → Phonetic
 */
export default function formatPN(name: unknown): string {
	if (!name) {
		return '';
	}

	// Handle array (e.g. PatientName là array từ QIDO/dcmjs)
	if (Array.isArray(name)) {
		return formatPN(name[0]);
	}

	// Handle PN object { Alphabetic?, Ideographic?, Phonetic? }
	if (typeof name === 'object') {
		const pn = name as Record<string, string>;
		const text = pn.Alphabetic || pn.Ideographic || pn.Phonetic || '';
		return _formatRawPN(text);
	}

	// Plain string
	return _formatRawPN(String(name));
}

/**
 * Format chuỗi PN thuần (có thể chứa ký tự ^)
 * "Smith^John^Middle" → "Smith, John Middle"
 */
function _formatRawPN(raw: string): string {
	if (!raw) {
		return '';
	}
	const parts = raw.split('^');
	const [last, ...rest] = parts;
	const restFiltered = rest.filter(Boolean);
	if (restFiltered.length > 0) {
		if (last) {
			return `${last}, ${restFiltered.join(' ')}`.trim();
		}
		return restFiltered.join(' ').trim();
	}
	return last.trim();
}

